// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file workspace/workspace_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { PersonalizedUser } from '../user/user_model_pb';
import { file_user_user_model } from '../user/user_model_pb';

/**
 * Describes the file workspace/workspace_model.proto.
 */
export const file_workspace_workspace_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch93b3Jrc3BhY2Uvd29ya3NwYWNlX21vZGVsLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCLtAQoVUGVyc29uYWxpemVkV29ya3NwYWNlEjIKCXdvcmtzcGFjZRgBIAEoCzIfLmNvbS5nZW0uYmZmLmNvbnRyYWN0LldvcmtzcGFjZRIyCgRyb2xlGAIgASgOMiQuY29tLmdlbS5iZmYuY29udHJhY3QuV29ya3NwYWNlLlJvbGUSEwoGcmVnaW9uGAMgASgJSACIAQESTAoQd29ya3NwYWNlU2V0dGluZxgEIAEoCzIyLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlBlcnNvbmFsaXplZFdvcmtzcGFjZVNldHRpbmdCCQoHX3JlZ2lvbiKnAQoJV29ya3NwYWNlEgwKBG5hbWUYASABKAkSGAoLZGVzY3JpcHRpb24YAiABKAlIAIgBARIWCglhdmF0YXJVcmwYAyABKAlIAYgBARISCgp1c2Vyc0NvdW50GAQgASgFIigKBFJvbGUSCgoGTUVNQkVSEAASCQoFQURNSU4QARIJCgVPV05FUhACQg4KDF9kZXNjcmlwdGlvbkIMCgpfYXZhdGFyVXJsIoABChRXb3Jrc3BhY2VQYXJ0aWNpcGFudBI0CgR1c2VyGAEgASgLMiYuY29tLmdlbS5iZmYuY29udHJhY3QuUGVyc29uYWxpemVkVXNlchIyCgRyb2xlGAIgASgOMiQuY29tLmdlbS5iZmYuY29udHJhY3QuV29ya3NwYWNlLlJvbGUieQocUGVyc29uYWxpemVkV29ya3NwYWNlU2V0dGluZxIcChRhbGxvd1VzZXJQcm9maWxlRWRpdBgBIAEoCBIgChhhbGxvd1VzZXJEaXNwbGF5TmFtZUVkaXQYAiABKAgSGQoRcmVxdWlyZU1pZGRsZU5hbWUYAyABKAhCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_user_user_model]
  );

/**
 * @generated from message com.gem.bff.contract.PersonalizedWorkspace
 */
export type PersonalizedWorkspace = Message<'com.gem.bff.contract.PersonalizedWorkspace'> & {
  /**
   * @generated from field: com.gem.bff.contract.Workspace workspace = 1;
   */
  workspace?: Workspace;

  /**
   * @generated from field: com.gem.bff.contract.Workspace.Role role = 2;
   */
  role: Workspace_Role;

  /**
   * @generated from field: optional string region = 3;
   */
  region?: string;

  /**
   * @generated from field: com.gem.bff.contract.PersonalizedWorkspaceSetting workspaceSetting = 4;
   */
  workspaceSetting?: PersonalizedWorkspaceSetting;
};

/**
 * Describes the message com.gem.bff.contract.PersonalizedWorkspace.
 * Use `create(PersonalizedWorkspaceSchema)` to create a new message.
 */
export const PersonalizedWorkspaceSchema: GenMessage<PersonalizedWorkspace> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_model, 0);

/**
 * @generated from message com.gem.bff.contract.Workspace
 */
export type Workspace = Message<'com.gem.bff.contract.Workspace'> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * @generated from field: optional string avatarUrl = 3;
   */
  avatarUrl?: string;

  /**
   * @generated from field: int32 usersCount = 4;
   */
  usersCount: number;
};

/**
 * Describes the message com.gem.bff.contract.Workspace.
 * Use `create(WorkspaceSchema)` to create a new message.
 */
export const WorkspaceSchema: GenMessage<Workspace> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_model, 1);

/**
 * @generated from enum com.gem.bff.contract.Workspace.Role
 */
export enum Workspace_Role {
  /**
   * @generated from enum value: MEMBER = 0;
   */
  MEMBER = 0,

  /**
   * @generated from enum value: ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: OWNER = 2;
   */
  OWNER = 2,
}

/**
 * Describes the enum com.gem.bff.contract.Workspace.Role.
 */
export const Workspace_RoleSchema: GenEnum<Workspace_Role> =
  /*@__PURE__*/
  enumDesc(file_workspace_workspace_model, 1, 0);

/**
 * @generated from message com.gem.bff.contract.WorkspaceParticipant
 */
export type WorkspaceParticipant = Message<'com.gem.bff.contract.WorkspaceParticipant'> & {
  /**
   * @generated from field: com.gem.bff.contract.PersonalizedUser user = 1;
   */
  user?: PersonalizedUser;

  /**
   * @generated from field: com.gem.bff.contract.Workspace.Role role = 2;
   */
  role: Workspace_Role;
};

/**
 * Describes the message com.gem.bff.contract.WorkspaceParticipant.
 * Use `create(WorkspaceParticipantSchema)` to create a new message.
 */
export const WorkspaceParticipantSchema: GenMessage<WorkspaceParticipant> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_model, 2);

/**
 * @generated from message com.gem.bff.contract.PersonalizedWorkspaceSetting
 */
export type PersonalizedWorkspaceSetting =
  Message<'com.gem.bff.contract.PersonalizedWorkspaceSetting'> & {
    /**
     * @generated from field: bool allowUserProfileEdit = 1;
     */
    allowUserProfileEdit: boolean;

    /**
     * @generated from field: bool allowUserDisplayNameEdit = 2;
     */
    allowUserDisplayNameEdit: boolean;

    /**
     * @generated from field: bool requireMiddleName = 3;
     */
    requireMiddleName: boolean;
  };

/**
 * Describes the message com.gem.bff.contract.PersonalizedWorkspaceSetting.
 * Use `create(PersonalizedWorkspaceSettingSchema)` to create a new message.
 */
export const PersonalizedWorkspaceSettingSchema: GenMessage<PersonalizedWorkspaceSetting> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_model, 3);
